import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/policy/:id',
    name: 'policyDetail',
    component: () => import('@/sub-app/policy/index.vue'),
    meta: {
      title: '协议',
      keepAlive: true
    }
  },

];

const router = new VueRouter({
  routes,
});


export default router;
